import {Component, OnInit, ViewChild} from '@angular/core';
import {ShoppingCartService} from '../../services/shopping-cart.service';
import {PaymentType} from './components/payment-selection/payment-selection.component';
import {StripePaymentComponent} from './components/stripe-payment/stripe-payment.component';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent  implements OnInit {
  paymentType: PaymentType;
  @ViewChild(StripePaymentComponent)  stripe: StripePaymentComponent;
  constructor(public cart: ShoppingCartService) {
    this.cart.paymentType ? this.paymentType = PaymentType[this.cart.paymentType] : this.paymentType = null;
    this.cart.priceChangedInbasket.subscribe(
      (data: boolean) => {
        if (data) {
          // invalidating payson previously sent request -IMPORTANT!
          this.cart.paysonSnippet = '';
          this.cart.paymentType = '';
          this.paymentType = null;
          this.ngOnInit();
        }
      });
  }

  ngOnInit() {
    this.cart.paymentType ? this.paymentType = PaymentType[this.cart.paymentType] : this.paymentType = null;
  }

  paymentTypeChanged(paymentType: PaymentType): void {
    this.paymentType = paymentType;
    this.cart.paymentType = paymentType;
    // invalidating payson previously sent request -IMPORTANT!
    this.cart.paysonSnippet = '';
    this.cart.saveBasket();

  }
}
